import HTTP from "@/_helpers/http";
import { PROFILE__API } from "@/_helpers/urls";
import { PROFILE__MUTATIONS } from "../mutation-types";
import { PROFILE__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

const state = {
  client: null,
  documentInfo: {
    identityVerification: "",
    residenceVerification: "",
    identityVerificationDocuments: [],
    residenceVerificationDocuments: [],
  },
  verifications: null,

  twoFaSetup: {
  qr: null,
  setup_token: null,
},
twoFaSetup: null,
};

const getters = {
  isValidToChangePassword(state) {
    if (
      state.password &&
      state.confirm_password &&
      state.password == state.confirm_password
    )
      return true;
    return false;
  },
};

const mutations = {
  SET_TWOFA_SETUP(state, payload) {
    state.twoFaSetup = payload;
  },
  CLEAR_TWOFA_SETUP(state) {
    state.twoFaSetup = null;
  },
  [PROFILE__MUTATIONS.TWOFA_SETUP](state, payload) {
  state.twoFaSetup.qr = payload.qr || null;
  state.twoFaSetup.setup_token = payload.setup_token || null;
  },
  [PROFILE__MUTATIONS.TWOFA_CLEAR](state) {
    state.twoFaSetup.qr = null;
    state.twoFaSetup.setup_token = null;
  },
  
  [PROFILE__MUTATIONS.PROFILE](state, client) {
    state.client = client;
  },
  [PROFILE__MUTATIONS.POPUPNOTICE](state, verifications) {
    state.verifications = verifications;
  },
  [PROFILE__MUTATIONS.IDENTITYVERIFICATION](state, payload) {
    state.documentInfo.identityVerification = payload;
  },
  [PROFILE__MUTATIONS.RESIDENCEVERIFICATION](state, payload) {
    state.documentInfo.residenceVerification = payload;
  },
  [PROFILE__MUTATIONS.IDENTITYVERIFICATIONDOCUMENTS](state, payload) {
    state.documentInfo.identityVerificationDocuments = payload;
  },
  [PROFILE__MUTATIONS.RESIDENCEVERIFICATIONDOCUMENTS](state, payload) {
    state.documentInfo.residenceVerificationDocuments = payload;
  },
};

const actions = {
  async [PROFILE__ACTIONS.GETPROFILE]({ commit }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).get(PROFILE__API.FETCHPROFILE);
      commit(PROFILE__MUTATIONS.PROFILE, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [PROFILE__ACTIONS.POPUPNOTICE]({ commit }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).get(PROFILE__API.POPUPNOTICE);
      commit(PROFILE__MUTATIONS.POPUPNOTICE, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [PROFILE__ACTIONS.CHANGETHEME]({ dispatch }, data) {
    try {
      const url = `${PROFILE__API.CHANGETHEME}`;
      const response = await HTTP().post(url, data);

      if (response.status === 200) {
        dispatch(PROFILE__ACTIONS.GETPROFILE);
        toast.success(response.data.message);
        return {
          success: true,
          status: 200,
        };
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed To Update Theme");
      return {
        success: false,
        status: error.response?.status || 500,
      };
    }
  },

  async [PROFILE__ACTIONS.CHANGE_PROFILE_URL]({ dispatch, commit }, data) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).post(PROFILE__API.CHANGE_PROFILE_URL, data);
      dispatch(PROFILE__ACTIONS.GETPROFILE);
      toast.success(response?.data?.message);
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message);
    }
  },

  async [PROFILE__ACTIONS.UPDATEPROFILEINFO]({ dispatch, commit }, data) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).post(PROFILE__API.UPDATEPROFILEINFO, data);
      dispatch(PROFILE__ACTIONS.GETPROFILE);
      toast.success(response?.data?.message);
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message);
    }
  },

  async [PROFILE__ACTIONS.FETCHDOCUMENTS]({ commit }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).get(PROFILE__API.FETCHDOCUMENTS);

      if (response.status === 200) {
        const { identityDocument, residenceDocument } = response.data;

        commit(
          PROFILE__MUTATIONS.IDENTITYVERIFICATIONDOCUMENTS,
          identityDocument
        );
        commit(
          PROFILE__MUTATIONS.RESIDENCEVERIFICATIONDOCUMENTS,
          residenceDocument
        );
      } else {
        const errorMessage = response.data.message;
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("An error occurred while fetching documents:", error);
    }
  },

  async [PROFILE__ACTIONS.IDENTITYVERIFICATION]({ commit, dispatch }, data) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).post(PROFILE__API.IDENTITYVERIFICATION, data);

      if (response.data.status === 200) {
        commit(
          PROFILE__MUTATIONS.IDENTITYVERIFICATION,
          response.data.documentUrl
        );
        await dispatch(PROFILE__ACTIONS.FETCHDOCUMENTS);
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  },

  async [PROFILE__ACTIONS.RESIDENCEVERIFICATION]({ commit, dispatch }, data) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).post(PROFILE__API.RESIDENCEVERIFICATION, data);

      if (response.data.status === 200) {
        commit(
          PROFILE__MUTATIONS.RESIDENCEVERIFICATION,
          response.data.documentUrl
        );
        await dispatch(PROFILE__ACTIONS.FETCHDOCUMENTS);
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  },

  async [PROFILE__ACTIONS.BECOMEANIB]({ dispatch, state }) {
    try {
      console.log(state)
      if(state.client.identity !== 1 || state.client.resident !== 1){
        return toast.error("Please Verify Your Account First");
      }
      const response = await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).post(PROFILE__API.BECOMEANIB);
      if (response.status === 200) {
        await dispatch(PROFILE__ACTIONS.GETPROFILE);
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  },

  async [PROFILE__ACTIONS.DELETEDOCUMENT]({ dispatch, commit }, id) {
    try {
      const response = await HTTP().delete(
        `${PROFILE__API.DELETEDOCUMENT}/${id}`
      );

      if (response.status === 200) {
        await dispatch(PROFILE__ACTIONS.DELETEDOCUMENT);
        toast.success(response.data.message || "Deleted successfully");
      }
    } catch (error) {
      console.log(error);
    }
  },

  //2 factor
  async [PROFILE__ACTIONS.TWOFA_START]({ commit }) {
  try {
    const res = await HTTP({ trackProgress: true, loadingText: "Processing..." })
      .post(PROFILE__API.TWOFA_START);

    if (res.status === 200 && res.data?.type === "success") {
      commit(PROFILE__MUTATIONS.TWOFA_SETUP, res.data);
      return res.data;
    }
    toast.error(res.data?.message || "Failed to start 2FA");
    return null;
  } catch (e) {
    console.error(e);
    toast.error("Failed to start 2FA");
    return null;
  }
},

async [PROFILE__ACTIONS.TWOFA_ENABLE]({ commit, dispatch }, payload) {
  try {
    const res = await HTTP({ trackProgress: true, loadingText: "Processing..." })
      .post(PROFILE__API.TWOFA_ENABLE, payload);

    if (res.status === 200 && res.data?.type === "success") {
      toast.success(res.data.message);
      commit(PROFILE__MUTATIONS.TWOFA_CLEAR);
      await dispatch(PROFILE__ACTIONS.GETPROFILE);
      return true;
    }
    toast.error(res.data?.message || "Failed to enable 2FA");
    return false;
  } catch (e) {
    console.error(e);
    toast.error("Failed to enable 2FA");
    return false;
  }
},

// new 2fa
async TWOFA_START({ commit }) {
    const res = await HTTP().post("/profile/2fa/start");
    commit("SET_TWOFA_SETUP", res.data);
    return res.data;
  },

  async TWOFA_ENABLE({ commit }, payload) {
    const res = await HTTP().post("/profile/2fa/enable", payload);
    commit("CLEAR_TWOFA_SETUP");
    return res.data?.type === "success";
  },

  async TWOFA_ACTIVATE(_, payload) {
    const res = await HTTP().post("/profile/2fa/activate", payload);
    return res.data?.type === "success";
  },

  async TWOFA_DISABLE(_, payload) {
    const res = await HTTP().post("/profile/2fa/disable", payload);
    return res.data?.type === "success";
  },
  
};

export default {
  namespaced: true,
  strict: true,
  state,
  getters,
  actions,
  mutations,
};
